const getGeolocationPermissionState = async () => {
  if ('permissions' in navigator) {
    return (await navigator.permissions.query({ name: 'geolocation' })).state;
  }

  return 'error';
};

export { getGeolocationPermissionState };
